import { useAsyncCallback } from 'react-async-hook';
import { useLatest } from 'react-use';
import stringify from 'safe-stable-stringify';
import { useInviteStore } from '../store/use-invite-store';
import { deepMerge } from '../utils/misc';
import { api } from './instance';

// This is used to patch the "progress" section of the invite object in the
// backend. Patching is done according to the JSON patch spec (TODO LINK). The
// API will NOT return any data but the front end may assume the a successful
// HTTP status code means the progress object was patched as requested. The same
// patch can the be applied locally. Any concurrent changes to the same invite
// in the backend can be ignored for now.
export function usePatchInvite() {
  const { patchInvite, invite } = useInviteStore();
  const latestInvite = useLatest(invite);

  return useAsyncCallback(async (patchData) => {
    const { reference, onlineBookingData: currentData } = latestInvite.current;
    const onlineBookingData = deepMerge(currentData, patchData);
    if (stringify(onlineBookingData) !== stringify(currentData)) {
      await api.auth.post('onlinebooking/update-data', {
        json: {
          bookingReference: reference,
          onlineBookingData,
        },
      });
      patchInvite(patchData);
      return true;
    } else {
      return true;
    }
  });
}
